<template>
  <div class="bf-box">
    <div class="" style="height: 65px; width: 100%; background-color: #000; position: fixed; z-index: 10;">

    </div>
    <div class="reader-container">
      <div class="reader-header">
        <div class="title">{{ title }}</div>
        <div></div>
        <div class="chapter-controls">
          <!-- <select v-model="currentChapterIndex" @change="onChapterChange" class="select">
            <option v-for="(ch, idx) in chapters" :key="idx" :value="idx">{{ ch.sortname }}</option>
          </select> -->
          <button class="btn" @click="prevChapter" :disabled="false">上一章</button>
          <button class="btn" @click="nextChapter" :disabled="false">下一章</button>
        </div>
      </div>

      <div class="reader-toolbar">
        <div class="left">
          <button class="btn" :class="{ active: fitMode === 'original' }" @click="fitMode = 'original'">原始尺寸</button>
          <button class="btn" :class="{ active: fitMode === 'width' }" @click="fitMode = 'width'">适应宽度</button>
        </div>
        <div class="right">
          <label class="switch">
            <input type="checkbox" v-model="isDark" />
            <span class="slider"></span>
          </label>
          <span class="switch-label">{{ isDark ? '夜间' : '日间' }}</span>
        </div>
      </div>

      <div class="reader-content" :class="[{ dark: isDark }, fitMode]">
        <div v-if="chapters.length" class="page-list">
          <img v-for="(src, i) in chapters" :key="i" :src="src.detail_image" class="page" @load="onImgLoad" />
        </div>
        <div v-else class="empty">本章节为付费章节，需要300硬币开通</div>
      </div>

      <div class="reader-footer">
        <div class="pager">
          <button class="btn" @click="scrollToTop">回到顶部</button>
          <span class="meta">共 {{ chapters.length }} 页</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'BrowseReader',
  data() {
    return {
      title: '',
      chapters: [
      ],
      currentChapterIndex: 0,
      images: [],
      fitMode: 'width', // 'original' | 'width'
      isDark: false
    }
  },
  mounted() {
    console.log(this.$route.params)
    this.QingAJAX(this.$route.params.Hid);//请求数据
  },
  methods: {
    //请求数据
    QingAJAX(Hid) {
      let data = {
        huashuid: Hid,
        sortid: this.$route.params.Mid
      }
      axios.post('/api/index/detail', data)
        .then(res => {
          console.log('首次进来的信息：', res.data);
          if (res.data.code == 1) {
            this.chapters = res.data.data.list;
            this.title = this.chapters[0].sortname || '漫画浏览'
            this.currentChapterIndex = res.data.data.endid;
          } else {
            //是会员章节必走这里
            const feeXiugaiStr = localStorage.getItem('FeeXiugai') || '';
            let nums = feeXiugaiStr.split(',').map(Number);
            const hasBigNum = nums.some(num=> num==Hid);
            
            console.log('要判断了，之前是否有值呢？',nums,hasBigNum)
            //判断是存在付费章节id
              if (hasBigNum) {
                let xinData = {
                  huashuid: Hid,
                  sortid: this.$route.params.Mid,
                  yhname: this.$store.state.dlMark !== null ? this.$store.state.dlMark.username : ''
                }
                axios.post('/api/index/detail', xinData).then(res => {
                  console.log('已购买后的信息2：', res);
                  this.chapters = res.data.data.list;
                  this.title = this.chapters[0].sortname || '漫画浏览'
                  this.currentChapterIndex = res.data.data.endid;
                }).catch(err => {
                  console.log(err);
                })
                return;
              } else {
                //如果不存在付费id 直接执行这里 弹窗付费
                this.$confirm('观看下一章节需要300硬币，是否继续？', '温馨提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {

                  //点击确认执行这里
                  //判断有没有登录
                  if (this.$store.state.dlMark !== null) {
                    if (this.$store.state.dlMark.money >= 300) {
                      const data = {
                        yhname: this.$store.state.dlMark.username,
                        num: this.$store.state.dlMark.money - 300,
                        comicid: this.$route.params.Mid,
                        huashu: Hid
                      }
                      //如果金额大于300 则执行此接口
                      axios.post('/api/index/goumaijl', data).then(res => {
                        console.log('成功购买', res);
                        if (res.data.code == 1) {
                          //传递参数
                          this.$store.state.dlMark.money = this.$store.state.dlMark.money - 300;
                          localStorage.setItem('zqW', JSON.stringify(this.$store.state.dlMark));
                          //给本地存储的 话术传
                          nums.push(Hid);
                          localStorage.setItem('FeeXiugai',nums);
                          let xinData = {
                            huashuid: Hid,
                            sortid: this.$route.params.Mid,
                            yhname: this.$store.state.dlMark !== null ? this.$store.state.dlMark.username : ''
                          }
                          //购买后重新请求，获取漫画信息
                          axios.post('/api/index/detail', xinData).then(res => {
                            console.log('购买后的信息：', res);
                            this.chapters = res.data.data.list;
                            this.title = this.chapters[0].sortname || '漫画浏览'
                            this.currentChapterIndex = res.data.data.endid;

                          }).catch(err => {
                            console.log(err);
                            
                          })
                        }
                      }).catch(err => {
                        console.log('购买失败', err)
                      })
                    } else {
                      this.$message.warning('您的账户余额不足，请充值后重试!');
                      this.$router.push('/topUp');
                    }
                  }else{
                      this.$message.warning('您还没有登录，请登录后重试！');
                      this.$router.push('/login');
                  }
                }).catch(() => {
                  //点击取消
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                });
              }

          }

        }).catch(err => {
          console.log(err);
        })
    },
    loadImages() {
      const chapter = this.chapters[this.currentChapterIndex]
      this.images = Array.isArray(chapter?.images) ? chapter.images : []
      this.$nextTick(() => this.scrollToTop())
    },
    onChapterChange() {
      this.loadImages()
    },
    //上一章节
    prevChapter() {
      if (this.chapters[0].huashu > 1) {
        let HSid = this.chapters[0].huashu - 1;
        console.log(HSid);
        this.QingAJAX(HSid);
        this.loadImages()
      } else {
        // console.log('上一章节')
        this.$message.warning('已是第一章！')
      }
    },
    //下一章节
    nextChapter() {
      if (this.chapters[0].huashu < this.currentChapterIndex) {
        let HSid = this.chapters[0].huashu + 1;
        console.log(HSid);
        this.QingAJAX(HSid);
        this.loadImages()
      } else {
        // console.log('下一章节')
        this.$message.warning('已是最后一章！')
      }
    },
    scrollToTop() {
      const el = this.$el.querySelector('.reader-content')
      if (el) el.scrollTop = 0
    },
    onImgLoad() {
      // 预留：图片加载完成后的逻辑（如懒加载、上报等）
    }
  }
}
</script>

<style lang="scss" scoped>
.bf-box {
  background: #ffffff;
}

.reader-container {
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 90px 16px 40px; // 与登录页上边距保持一致
}

.reader-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.title {
  font-size: 22px;
  font-weight: 600;
  color: #1a1a1a;
}

.chapter-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.select {
  height: 38px;
  padding: 0 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  color: #333;
}

.btn {
  height: 38px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: #ffffff;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #667eea;
    color: #667eea;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
  }

  &.primary {
    background: #667eea;
    color: #fff;
    border-color: #667eea;

    &:hover {
      background: #5568d3;
      border-color: #5568d3;
    }
  }

  &.active {
    border-color: #667eea;
    color: #667eea;
  }
}

.reader-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #f0f0f0;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
}

.reader-toolbar .left {
  display: flex;
  gap: 8px;
}

.reader-toolbar .right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e5e7eb;
  transition: .2s;
  border-radius: 999px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .2s;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.switch input:checked+.slider {
  background-color: #667eea;
}

.switch input:checked+.slider:before {
  transform: translateX(22px);
}

.switch-label {
  font-size: 13px;
  color: #666;
}

.reader-content {
  height: calc(100vh - 250px);
  overflow: auto;
  background: #f7f7fb;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 16px;
}

.reader-content.dark {
  background: #0f1115;
}

.page-list {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  width: auto;
  max-width: 100%;
  // border-radius: 8px;
  // box-shadow: 0 1px 8px rgba(0,0,0,0.06);
  background: #fff;
}

.reader-content.width .page {
  width: 100%;
  height: auto;
}

.reader-content.original .page {
  max-width: 100%;
}

.empty {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

.reader-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 12px;
}

.pager {
  display: flex;
  align-items: center;
  gap: 12px;
}

.meta {
  font-size: 13px;
  color: #666;
}

@media (max-width: 600px) {
  .reader-container {
    padding: 70px 10px 20px;
  }

  .reader-content {
    height: calc(100vh - 220px);
  }
}
</style>